import React, { useEffect, useState } from 'react';
import styles from "../../asset/css/homePage.module.css";
import { Images } from '../../data/Images';
import { ImageSVG } from '../../data/svgImages';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import Header from '../../components/global/Header';
import ThemeImg from '../../components/global/ThemeImg';
import { getAllLandingHeaderContent, getSocialMedaiLink, listOfCms } from '../../actions/cmsActions';
import toast from 'react-hot-toast';
import { getallsalehook, subscribe } from '../../actions/userAction';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

const footerData = [
    {
        title: 'LOREM IPSUM',
        links: [
            { name: 'Contact us', path: '/' },
            { name: 'How it works', path: '/' },
            { name: 'Create', path: '/' },
        ],
    },
    {
        title: 'LOREM IPSUM',
        links: [
            { name: 'Contact us', path: '/' },
            { name: 'How it works', path: '/' },
            { name: 'Create', path: '/' },
        ],
    },
    {
        title: 'LOREM IPSUM',
        links: [
            { name: 'Explore', path: '/' },
            { name: 'Team & Services', path: '/' },
        ],
    },
    {
        title: 'LOREM IPSUM',
        links: [
            { name: 'Investment', path: '/' },
            { name: 'Portal', path: '/' },
        ],
    },
    {
        title: 'LOREM IPSUM',
        links: [
            { name: 'Help center', path: '/' },
            { name: 'partners', path: '/' },
        ],
    },
];

export default function HomePage() {
    const [cmsContentHome, setCmsContentHome1] = useState();
    const [twitterLink, setTwitterLink] = useState("");
    const [telegramLink, setTelegramLink] = useState("");
    const [facebookLink, setFacebookLink] = useState("");
    const [discordLink, setDiscordLink] = useState("");

    const getAllCmsList = async () => {
        try {
            const result = await listOfCms();
            if (result.statusCode == 200 && result.status == true) {
                setCmsContentHome1(result.data)
            }

        } catch (error) {

        }
    };

    const splitTitle = (title) => {
        const words = title.split(' ');

        const firstPart = words.slice(0, 2).join(' ');
        const secondPart = words.slice(2).join(' ');
        const thirdPart = words.slice(4, 5).join(' ');
        return { firstPart, secondPart, thirdPart };
    };

    // const splitTitle = (title) => {
    //     const words = title.split(' ');
    //     const parts = [];
    //     // Split into chunks of 2 words
    //     for (let i = 0; i < words.length; i += 2) {
    //         parts.push(words.slice(i, i + 2).join(' ')); // Adjust '2' if you want a different chunk size
    //     }
    //     return parts;
    // };

    const [subscribeValue, setSubscribeValue] = useState({
        email: ''
    });
    const handleSaveSubscribe = async (e) => {
        try {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            if (!emailRegex.test(subscribeValue.email)) {
                toast.error("Please enter a valid email address.");
                return;
            }

            let payload = { data: subscribeValue };
            const submitValue = await subscribe(payload);

            if (submitValue.statusCode == 200 && submitValue.status == true) {
                toast.success(submitValue.message);
                return;
            } else {
                toast.error(submitValue.message);
                return;
            }
        } catch (error) {

        }
    }

    const getAllSocialMediaLink = async () => {
        try {
            const list = await getSocialMedaiLink();
            setTwitterLink(list.data[0].twitter)
            setTelegramLink(list.data[0].telegram)
            setFacebookLink(list.data[0].facebook)
            setDiscordLink(list.data[0].discord)
        } catch (error) {

        }
    }

    useEffect(() => {
        getAllCmsList();
        getAllSocialMediaLink();
        getSaleData()

    }, [localStorage.getItem("saleaddress")]);

    const getSaleData = async () => {



        const getSalefromDb = await getallsalehook()
        if (getSalefromDb?.data?.data.length > 0) {

            localStorage.setItem("saleaddress", getSalefromDb?.data && getSalefromDb?.data?.data[0].saleAddress)
        } else {
            localStorage.setItem("saleaddress", "nosale")

        }


    }

    return (
        <div className={`${styles.homePage} homePagelayout`}>
            <Header />
            <section className={styles.bannerSection}>
                <div className={styles.contentPart}>
                    {cmsContentHome && cmsContentHome.map((item, index) => {
                        const { firstPart, secondPart, thirdPart } = splitTitle(item.title);

                        return (
                            <div key={index}>
                                <div>
                                    {item.identifier === 'Home page 1' ? (
                                        <>
                                            <h2 className="madani_arabic_bold">
                                                <span className={styles.greenText}>{firstPart}{' '}</span>
                                                <br />
                                                <span>{secondPart}</span>
                                                <br />
                                                <span className={styles.greenText}>{thirdPart}{' '}</span>
                                            </h2>
                                            <br />
                                            <p>{ReactHtmlParser(item.content)}</p>
                                        </>
                                    ) : (
                                        <>
                                            <span></span>
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    })}

                    {/* <div className={styles.btnWrapper}>
                        <button className='primaryBtn'>learn more</button>
                        <button className='secondaryBtn'>learn more</button>
                    </div> */}
                </div>
                <div className={styles.bannerBgPatten}>
                    <img className={styles.circleShapeImg1} src={Images.circleShapeImg1} alt="circle Shape" />
                    <img className={styles.circleShapeImg2} src={Images.circleShapeImg2} alt="circle Shape" />
                    <img className={styles.circleShapeImg3} src={Images.circleShapeImg3} alt="circle Shape" />
                    <img className={styles.circleShapeImg4} src={Images.circleShapeImg4} alt="circle Shape" />
                    <img className={styles.circleShapeImg5} src={Images.circleShapeImg5} alt="circle Shape" />
                    <img className={styles.circleShapeImg6} src={Images.circleShapeImg6} alt="circle Shape" />
                    <img className={styles.circleShapeImg7} src={Images.circleShapeImg7} alt="circle Shape" />
                    <img className={styles.homeBannerBottomImg} src={Images.homeBannerBottomImg} alt="circle Shape" />
                </div>
            </section>
            <section className={styles.launchpadSection}>
                <div className={styles.leftPart}>
                    <ThemeImg dynamicPath={"homeHandImg"} />
                </div>
                <div className={styles.rightPart}>
                    {cmsContentHome && cmsContentHome.map((item, index) => {
                        const { firstPart, secondPart, thirdPart } = splitTitle(item.title);

                        return (
                            <div key={index}>
                                <div>
                                    {item.identifier === 'launchpad' ? (
                                        <>
                                            <h3 className={styles.titleText}>{item.title}</h3>
                                            <div className='dynamicHtmlElement'>{ReactHtmlParser(item.content)} </div>
                                        </>
                                    ) : (
                                        <>
                                            <span></span>
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    })}


                    {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus luctus, augue id sollicitudin consequat, elit orci scelerisque metus, eu faucibus risus tortor id nulla. Duis sed tellus nec quam finibus iaculis non a eros. </p> */}
                    {/* <button className="primaryBtn">Learn more</button> */}
                </div>
                <div className={styles.launchpadBgPatten}>
                    <img className={styles.circleShapeImg8} src={Images.circleShapeImg8} alt="circle Shape" />
                    <img className={styles.circleShapeImg9} src={Images.circleShapeImg9} alt="circle Shape" />
                    {/* <ThemeImg dynamicPath={"themeCoinImg1"} dynamicClass={"darkThemeCoinImg10"} /> */}
                    <div className={styles.darkThemeCoinImg10}>
                        <ThemeImg dynamicPath={"themeCoinImg1"} />
                    </div>
                </div>

            </section>
            <section className={styles.tokenomicsSection}>
                <div className={styles.titlePart}>
                    <h2 className={"madani_arabic_bold"}>Nexus DAO Integration</h2>
                    <p>Nexus Launchpad is a Solana-exclusive fair launch platform designed to support high-quality projects with a transparent and community-driven funding model. To enhance decentralization and governance, integrating a DAO (Decentralized Autonomous Organization) will allow the community to have an active role in decision-making and project selection.</p>
                </div>
                <div className={styles.contentPart}>
                    <h3 className='madani_arabic_bold'>Key Aspects of DAO Integration</h3>
                    <div className={styles.keyAspectsCardWrapper}>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <img src={Images.tokenomicsIcon1} alt='tokenomics' />
                                <h3>DAO Governance Model</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        Nexus DAO will oversee project selection, funding allocations, and ecosystem development.
                                    </li>
                                    <li>
                                        Governance will be token-based, allowing users to vote on decisions related to the launchpad.

                                    </li>
                                    <li>
                                        Staked or governance tokens $NXUS will be used for voting power.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <img src={Images.tokenomicsIcon2} alt='tokenomics' />
                                <h3>Fair Launch & Community Decision-Making</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        The DAO can approve or reject project applications for the launchpad.
                                    </li>
                                    <li>
                                        Projects may undergo a community vetting process, with DAO members reviewing key details before a launch.
                                    </li>
                                    <li>
                                        Governance proposals will cover funding models, token allocations, and partnerships.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <img src={Images.tokenomicsIcon3} alt='tokenomics' />
                                <h3>DAO Treasury & Rewards</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        A portion of platform fees (from token launches, swaps, or services) will go to the Nexus DAO treasury.
                                    </li>
                                    <li>
                                        DAO members can propose and vote on fund allocations, including grants, partnerships, and incentives.
                                    </li>
                                    <li>
                                        Stakers and active voters may receive rewards from treasury funds in the form of $Rubix, USDC, or other assets.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <img src={Images.tokenomicsIcon4} alt='tokenomics' />
                                <h3>Staking & Voting Mechanism</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        Users will be able to stake tokens to participate in governance.
                                    </li>
                                    <li>
                                        Voting can be implemented via Snapshot-style off-chain proposals or on-chain governance for full transparency.
                                    </li>
                                    <li>
                                        Quadratic voting or weighted voting models may be explored to balance community participation.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.tokenBgPatten}>
                    <img className={styles.circleShapeImg10} src={Images.circleShapeImg10} alt="circle Shape" />
                    <img className={styles.circleShapeImg11} src={Images.circleShapeImg11} alt="circle Shape" />
                    <img className={styles.circleShapeImg12} src={Images.circleShapeImg12} alt="circle Shape" />
                    <img className={styles.circleShapeImg13} src={Images.circleShapeImg13} alt="circle Shape" />
                    <img className={styles.circleShapeImg14} src={Images.circleShapeImg14} alt="circle Shape" />
                </div>
            </section>
            <section className={`${styles.tokenomicsSection} ${styles.tokenomicsSection2} `}>
                <div className={styles.titlePart}>
                    <h2 className={"madani_arabic_bold"}>Nexus AI Integration</h2>
                    <p>Nexus Launchpad is a Solana-based fair launch platform designed to support high-quality projects through decentralized, transparent fundraising. By integrating AI-powered tools, Nexus aims to enhance project evaluation, risk assessment, community engagement, and investor decision-making, making the launch process more efficient and data-driven.</p>
                </div>
                <div className={styles.contentPart}>
                    <h3 className='madani_arabic_bold'>Key Aspects of AI Integration</h3>
                    <div className={styles.keyAspectsCardWrapper}>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <h3>AI-Powered Project Evaluation & Due Diligence</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        AI algorithms analyze project fundamentals, including team credibility, tokenomics, and smart contract security.
                                    </li>
                                    <li>
                                        Machine learning models assess historical trends and market conditions to predict project viability.
                                    </li>
                                    <li>
                                        Automated fraud detection helps flag suspicious projects, preventing scams or rug pulls.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <h3>AI-Driven Investor Insights & Risk Assessment</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        AI provides real-time risk scores for projects based on on-chain activity, social sentiment, and tokenomics.
                                    </li>
                                    <li>
                                        Predictive analytics help investors evaluate potential ROI and compare projects launching on Nexus.
                                    </li>
                                    <li>
                                        NLP (Natural Language Processing) scans community discussions, GitHub activity, and whitepapers to highlight key concerns.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <h3>AI-Powered Chatbot for Community & Support (DEFAI)</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        DEFAI (Decentralized AI Assistant) will assist users by providing.
                                    </li>
                                    <li>
                                        Project insights and key metrics in real-time.
                                    </li>
                                    <li>
                                        Guidance on participating in fair launches, wallet setup, and staking.
                                    </li>
                                    <li>
                                        DAO proposal summaries for governance decisions.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <h3>AI-Driven Smart Matching for Investors & Projects</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        AI recommends projects to users based on investment preferences, past activity, and risk appetite.
                                    </li>
                                    <li>
                                        Helps projects find early supporters based on historical investment patterns and community behavior.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <h3>AI-Powered Tokenomics & Fund Distribution Optimization</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        AI models optimize token distribution strategies, ensuring fair and sustainable launch models.
                                    </li>
                                    <li>
                                        Smart contract automation ensures funds are allocated efficiently based on predefined AI-driven metrics.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.networksBgPatten}>
                    <img className={styles.circleShapeImg15} src={Images.circleShapeImg15} alt="circle Shape" />
                    <img className={styles.circleShapeImg16} src={Images.circleShapeImg16} alt="circle Shape" />
                    <img className={styles.circleShapeImg17} src={Images.circleShapeImg17} alt="circle Shape" />
                    <img className={styles.circleShapeImg18} src={Images.circleShapeImg18} alt="circle Shape" />
                    <img className={styles.threeLineImg} src={Images.threeLineImg} alt="circle Shape" />
                </div>
            </section>
            <section className={styles.joinCommunitySection}>
                <div className={styles.titlePart}>
                    <h2 className='madani_arabic_bold'>Join the community</h2>
                </div>
                <div className={styles.cardWrapper}>
                    <div className={styles.cardPart}>
                        <div>
                            {ImageSVG.TwitterSVG}
                        </div>
                        <a href={twitterLink} target='_blank'>

                            <button className='primaryBtn' value={twitterLink}>Twitter</button>
                        </a>
                    </div>
                    {/* <div className={styles.cardPart}>
                        <div>
                            {ImageSVG.TelegramSVG}
                        </div>
                        <a href={telegramLink} target='_blank'>

                            <button className='primaryBtn' value={telegramLink}>Telegram</button>
                        </a>
                    </div>
                    <div className={styles.cardPart}>
                        <div>
                            {ImageSVG.FacebookSVG}
                        </div>
                        <a href={facebookLink} target='_blank'>

                            <button className='primaryBtn' value={facebookLink}>Facebook</button>
                        </a>
                    </div> */}
                    <div className={styles.cardPart}>
                        <div>
                            {ImageSVG.DiscordSVG}
                        </div>
                        <a href={discordLink} target='_blank'>

                            <button className='primaryBtn' value={discordLink}>Discord</button>
                        </a>
                    </div>
                </div>
            </section>
            <section className={styles.footerSection}>
                <div className={styles.contentPart}>
                    <div className={styles.imagePart}>
                        <ThemeImg dynamicPath={"footerNexusLogo"} />
                    </div>
                    <div>
                        {cmsContentHome && cmsContentHome.map((item, index) => {
                            const { firstPart, secondPart, thirdPart } = splitTitle(item.title);

                            return (
                                <div key={index}>
                                    <div>
                                        {item.identifier === 'Footer content' ? (
                                            <>
                                                <p>{ReactHtmlParser(item.content)} </p>
                                            </>
                                        ) : (
                                            <>
                                                <span></span>
                                            </>
                                        )}
                                    </div>
                                </div>


                            );
                        })}

                        {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus luctus, augue id sollicitudin consequat, elit orci scelerisque metus </p> */}
                    </div>
                    <div>
                        {/* <input type="email" placeholder='Your Email Address'
                            onChange={(e) => setSubscribeValue({ ...subscribeValue, email: e.target.value })} />
                        <button className='primaryBtn'
                            onClick={handleSaveSubscribe}>Subscribe</button> */}
                    </div>

                    <div className={styles.socialMediaIcons}>
                        <ul>
                            <li >
                                <a href={twitterLink} target='_blank'>

                                    <img src={Images.twitterIcon} alt="twitter" />
                                </a>
                            </li>
                            {/* <li>
                                <a href={telegramLink} target='_blank'>
                                    <img src={Images.telegramIcon} alt="telegram" />
                                </a>
                            </li>
                            <li>
                                <a href={facebookLink} target='_blank'>
                                    <img src={Images.facebookIcon} alt="facebook" />
                                </a>
                            </li> */}
                            <li>
                                <a href={discordLink} target='_blank'>
                                    <img src={Images.discordIcon} alt="discord" />
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* <div className={styles.footerLists}>
                        {footerData.map((list, index) => (
                            <ul key={index}>
                                <li><h2 >{list.title}</h2></li>
                                {list.links.map((link, idx) => (
                                    <li key={idx}>
                                        <Link to={link.path}>{link.name}</Link>
                                    </li>
                                ))}
                            </ul>
                        ))}
                    </div> */}

                </div>
                <div className={styles.footerBgPatten}>
                    <img className={styles.circleShapeImg19} src={Images.circleShapeImg19} alt="circle Shape" />
                    <img className={styles.threeLineImg} src={Images.leftThreeLine} alt="circle Shape" />
                    <img className={styles.circleShapeImg20} src={Images.circleShapeImg20} alt="circle Shape" />
                    {/* <ThemeImg dynamicPath={"themeCoinImg1"} dynamicClass={"darkThemeCoinImg21"} /> */
                    }
                    <div className={styles.darkThemeCoinImg21}>
                        <ThemeImg dynamicPath={"themeCoinImg1"} />
                    </div>
                </div>
            </section>
        </div>
    )
}

